// Per-page <title> and meta description. Keyed by route path.
const SITE = "MYREDFOLDER®";

export const defaultMeta = {
  title: `${SITE} | Family emergency planning`,
  description:
    "Build a family emergency plan, agree on meeting places, stay connected, and keep important information in one place. Offered by MYREDFOLDER, Inc. and administered by NEPTA.",
};

const pageMeta = {
  "/": defaultMeta,
  "/home": defaultMeta,
  "/aboutUs/our-history": {
    title: `Our Story | ${SITE}`,
    description: "How MYREDFOLDER® began, and how it helps families turn preparedness into a plan they can use.",
  },
  "/aboutUs/our-team": {
    title: `Meet the Team | ${SITE}`,
    description: "Meet the people at MYREDFOLDER, Inc. and NEPTA who help families plan ahead.",
  },
  "/aboutUs/our-values": {
    title: `Our Mission & Values | ${SITE}`,
    description: "Our mission is to help families turn preparedness into a practical plan they can understand, use, and update.",
  },
  "/aboutUs/our-roles": {
    title: `Why Planning Matters | ${SITE}`,
    description: "A household plan answers the questions that matter before an emergency: who checks on whom, where to meet, and where your records are.",
  },
  "/aboutUs/events": {
    title: `Events Calendar | ${SITE}`,
    description: "Upcoming MYREDFOLDER® preparedness sessions, with dates, hosts, locations, and registration links.",
  },
  "/aboutUs/contact-us": {
    title: `Contact Us | ${SITE}`,
    description: "Questions about your account, organizational programs, or privacy? Get in touch with the MYREDFOLDER® team.",
  },
  "/ourServices/my-mrf-plan": {
    title: `MYREDFOLDER® Plan | Household emergency plan`,
    description: "Create a household plan: add contacts, meeting places, and relevant hazards; organize records and property information; review it with your family.",
  },
  "/ourServices/my-mrf-app": {
    title: `MYREDFOLDER® App | Your Family. Your Plan.`,
    description: "Your family's emergency plan, communication tools, important documents, and checklists in one secure platform. Prepare before, stay connected during, and recover after an emergency.",
  },
  "/ourServices/supply-kits": {
    title: `Go Kits / Supply Kits | ${SITE}`,
    description: "A digital plan works best alongside physical supplies. Prepare a go kit for each household member, including pets.",
  },
  "/business": {
    title: `For Employers & Communities | ${SITE}`,
    description: "Offer household preparedness through employers, associations, houses of worship, and communities, with NEPTA support for rollout.",
  },
  "/government": {
    title: `Government | ${SITE}`,
    description: "Government program details for MYREDFOLDER® are coming soon.",
  },
  "/knowledgeBase/risk-by-location": {
    title: `Disaster Resource Library | ${SITE}`,
    description: "Guides to the hazards relevant to your household and location: plan ahead, and follow local authorities during an event.",
  },
  "/knowledgeBase/risk-by-location-detail": {
    title: `Hazard guide | Disaster Resource Library | ${SITE}`,
    description: "How to plan ahead, what to do during, and how to organize recovery after a specific hazard.",
  },
  "/knowledgeBase/blog": {
    title: `Blog | ${SITE}`,
    description: "Practical preparedness articles from the MYREDFOLDER® team.",
  },
  "/knowledgeBase/faq": {
    title: `FAQ | ${SITE}`,
    description: "Answers about Premium membership, the trial, who can see your family information, cancelling, and the roles of MYREDFOLDER, Inc. and NEPTA.",
  },
  "/knowledgeBase/myredfolder-tribe": {
    title: `MYREDFOLDER® Tribe | ${SITE}`,
    description: "Join the MYREDFOLDER® preparedness community for practical articles and updates. The newsletter is free.",
  },
  "/knowledgeBase/newsletter": {
    title: `Newsletter | ${SITE}`,
    description: "Sign up for the free MYREDFOLDER® newsletter.",
  },
  "/pricing": {
    title: `Pricing | ${SITE} Premium`,
    description: "Choose how to pay for MYREDFOLDER® Premium: monthly or yearly.",
  },
  "/walmart": {
    title: `Premium for eligible Walmart associates | ${SITE}`,
    description: "MYREDFOLDER® Premium for eligible Walmart associates.",
  },
  "/security": {
    title: `Security | ${SITE}`,
    description: "Security at MYREDFOLDER®.",
  },
  "/privacy-policy": {
    title: `Privacy Policy | ${SITE}`,
    description: "The MYREDFOLDER® privacy policy.",
  },
};

export const getPageMeta = (pathname) => pageMeta[pathname] || defaultMeta;
